/** @jsxImportSource @emotion/react */
import React from 'react';
import { styled } from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

// const SmallTextField = styled(TextField)(({theme}) => ({
//   "& .MuiInputBase-root": {
//     fontSize: '0.5rem',
//     padding: '0.25rem',
//   },
// }))




function InputNameKanji(props) {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      checkBox: false,
      textBox: "",
      pullDown: "",
    },
  });


  const styles = {
    
    textarea:{
      width: '90%',
       mr: 5,
      '& .MuiInputBase-input':{
        fontSize: props.textSize,
      },
      '& .MuiInputBase-root':{
        // padding: '3px 0.5rem',
      },
      '& .MuiInputLabel-root':{
        fontSize: props.textSize,
      }
    },
  }
  return (
    <>
      <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
        <Controller
          control={control}
          name="sei_kanji"
          render={({ field }) => (
            <TextField
              {...field}
              label="姓"
              id="sei_kanji"
              size="small"
              disabled={props.disabled}
              css={styles.textarea}
              defaultValue={props.sei_kanji}
            />
          )}
        />
      </Grid>
      <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
        <Controller
          control={control}
          name="mei_kanji"
          render={({ field }) => (
            <TextField
              {...field}
              label="名"
              id="mei_kanji"
              size="small"
              disabled={props.disabled}
              css={styles.textarea}
              defaultValue={props.mei_kanji}
            />
          )}
        />
      </Grid>
    </>
  )
}


export default InputNameKanji;